<template>
  <div>
    <div class="header">
      <el-button type="primary" size="small" @click="addCommonParamHandler()">添加</el-button>
      <el-button type="primary" size="small" @click="dialogVisible1()">批量删除</el-button>
      <el-input
        class="search"
        size="small"
        placeholder="名称搜索"
        icon="el-icon-eleme"
        v-model="searchKey"
        @keyup.enter.native="queryCommonParamList" :on-icon-click="queryCommonParamList"
        style="margin-left: 10px;"></el-input>
      <el-input
        class="search"
        size="small"
        placeholder="值搜索"
        icon="el-icon-eleme"
        v-model="searchVla"
        @keyup.enter.native="queryCommonParamList" :on-icon-click="queryCommonParamList"
        style="margin-left: 10px;"></el-input>

      <el-select v-model="selectGroupIdVal" placeholder="分组请选择" style="width:130px;margin-left: 10px" size="small"
                 clearable>
        <el-option v-for="item in options" :key="item.id" :label="item.name" :value="item.id"></el-option>
      </el-select>

      <el-button type="primary" size="small" @click="queryCommonParamList" style="margin-left: 10px">搜索</el-button>

      <el-dialog :title="dialogTitle" :visible.sync="dialogFormVisible" width="40%" top="0"
                 :close-on-click-modal="false">
        <el-form ref="form" :model="form" label-width="80px" size="small">
          <el-form-item label="名称">
            <el-input v-model="form.name"></el-input>
          </el-form-item>
          <!-- <el-form-item label="值"><el-input v-model="form.paramInfo"></el-input></el-form-item> -->

          <el-form-item label="值">
            <el-input type="textarea" v-model="form.paramInfo"></el-input>
          </el-form-item>

          <el-form-item label="类型">
            <el-select v-model="selectParamTypevalue" placeholder="请选择" style="width: 100%;">
              <el-option v-for="item in paramTypeOptions" :key="item.value" :label="item.label"
                         :value="item.value"></el-option>
            </el-select>
          </el-form-item>

          <el-form-item label="描述">
            <el-input type="textarea" v-model="form.paramDesc"></el-input>
          </el-form-item>

          <el-form-item label="分组">
            <el-select v-model="selectGroupIdvalue" placeholder="请选择" style="width: 100%;" :disabled="isdisabledFn">
              <el-option v-for="item in options" :key="item.id" :label="item.name" :value="item.id"></el-option>
            </el-select>
          </el-form-item>
          <el-form-item v-if="seeBlock">
            <el-button type="primary" @click="ReferencedView()" size="small">被引用查看</el-button>
          </el-form-item>

        </el-form>
        <div slot="footer" class="dialog-footer">
          <el-button @click="dialogFormVisible = false" size="small">取 消</el-button>
          <el-button type="primary" @click="editCommonParamHander()" size="small">确 定</el-button>
        </div>
      </el-dialog>

      <el-dialog
        :visible.sync="dialogVisible"
        width="30%"
      >
        <span v-if='form.ids == 0'>请选择数据</span>
        <p style="margin: 0px;height: 40px; line-height: 44px;" v-if="form.ids != 0">
          <i class="el-icon-delete-solid" style="font-size: 40px; color:#409EFF;float: left;"></i>
          <span style="float: left;">确定删除吗？</span>
        </p>
        <span slot="footer" class="dialog-footer">
			    <el-button @click="dialogVisible = false" size="small">取 消</el-button>
			    <el-button type="primary" @click="delCommonPara()" size="small">确 定</el-button>
			  </span>
      </el-dialog>


      <!-- 分页 -->
      <el-pagination
        class="paging"
        background
        @size-change="handleSizeChange"
        @current-change="handleCurrentChangeParam"
        :current-page.sync="form.pageNo"
        :page-size="form.pageSize"
        layout="total, prev, pager, next"
        :pager-count="7"
        :total="totalParamCount">
      </el-pagination>
    </div>

    <div :style="{height:tableHeight - 40+'px'}">
      <el-table
        :maxHeight="tableHeight - 40+'px'"
        size="small"
        ref="multipleTable"
        :data="tableParamData"
        tooltip-effect="dark"
        border
        style="width: 100%;border: 1px solid #EBEEF5;"
        @selection-change="handleSelectionChange = arguments[0]"
      >
        <el-table-column type="selection" width="40"></el-table-column>
        <el-table-column prop="name" label="名称">
        </el-table-column>
        <el-table-column prop="paramInfo" label="值"></el-table-column>
        <el-table-column label="类型" width="100" align="center">
          <template scope="scope">
            <div v-if="scope.row.type == type.STRING.code">string</div>
            <div v-if="scope.row.type == type.INT.code">int</div>
            <div v-if="scope.row.type == type.BOOLEAN.code">boolean</div>
            <div v-if="scope.row.type == type.ARRAY.code">array</div>
            <div v-if="scope.row.type == type.OBJECT.code">object</div>
            <!-- <div v-else >PC</div> -->
          </template>
        </el-table-column>
        <el-table-column prop="gname" label="所属分组"></el-table-column>
        <!--	<el-table-column prop="date" label="时间"  width="120" align="center"></el-table-column>-->
        <el-table-column label="操作" width="120" show-overflow-tooltip align="center">
          <template scope="scope">
            <el-button type="primary" size="small" @click="editParamHander(scope.row)">编辑</el-button>
            <!-- <el-button type="primary" size="small">查看</el-button> -->
          </template>
        </el-table-column>
      </el-table>
    </div>
    <!-- 被引用查看 -->
    <el-dialog title="被引用查看" :visible.sync="dialogTableVisible" width="80%" top="0" :close-on-click-modal="false">
      <el-table :data="formTo.tableParamData" border :maxHeight="tableHeight - 70 +'px'">
        <!--		  <el-table-column property="pname" label="产品名称"></el-table-column>-->
        <el-table-column property="tname" label="终端类型"></el-table-column>
        <el-table-column property="gname" label="组"></el-table-column>
        <el-table-column property="paramName" label="参数"></el-table-column>

        <el-table-column label="操作" width="120" show-overflow-tooltip align="center">
          <template scope="scope">
            <el-button type="primary" size="small" @click="CancelTheReference(scope.$index, scope.row)">取消引用</el-button>
          </template>
        </el-table-column>
      </el-table>
    </el-dialog>
  </div>
</template>

<script>
  import constants from '@/js/constants.js'
  import {mapState} from 'vuex';
  import api from '@/api/public/';

  //添加一个的类型
  const type = constants.type;

  export default {
    data() {
      return {
        dialogVisible: false,
        isdisabledFn: false,
        seeBlock: false,
        dialogFormVisible: false,
        dialogTableVisible: false,
        type,
        paramTypeOptions: constants.options,
        searchKey: '',
        searchVla: '',
        dialogTitle: '',
        form: {
          id: '',
          name: '',
          paramInfo: '',
          ids: [],
          paramDesc: '',
          pageSize: 15,
          pageNo: 1,//当前页码
          totalPage: 0,//总页数
          //paginationShow: true,//是否显示分页
          totalCount: 0,//总条数
        },
        formTo: {
          name: '',
          commGropId: '',
          pageSize: 15,
          pageNo: 1,//当前页码
          totalCount: 0,//总条数
          tableParamData: []
        },
        tableParamData: [],
        selectParamTypevalue: '',
        selectGroupIdvalue: "1",
        selectGroupIdVal: "",
        options: [],
        totalParamCount: 0,
        handleSelectionChange: [],
        token: ''
      };
    },
    methods: {
      //改变每页显示数量时调用
      handleSizeChange(val) {
        this.$nextTick(() =>
          this.queryCommonGroupList(),
        )
      },
      //点击下一页和点击页码时执行
      handleCurrentChange(val) {
        this.form.pageNo = val;
        this.queryCommonGroupList();
      },
      handleCurrentChangeParam(val) {
        this.form.pageNo = val;
        this.queryCommonParamList();
      },
      // 取消引用
      CancelTheReference(index, val) {
        var data = {
          'paramId': val.paramid,
          'token': this.token,
        };
        api.editparamDeleteReferencesId(data).then(res => {
          if (res.data.code == 0) {
            this.formTo.tableParamData.splice(index, 1);
            successMsg({message: "取消引用成功"})
          } else {
            console.log(res.data.msg);
          }
        })
      },
      // 被引用查看
      ReferencedView() {
        this.dialogTableVisible = true;
        var data = {
          'name': this.formTo.name,
          'pageNo': this.formTo.pageNo,
          'pageSize': this.formTo.pageSize,
          'token': this.token,
          'commGropId': this.formTo.commGropId
        };
        api.queryparamByComm(data).then(res => {
          if (res.data.code == 0) {
            this.formTo.tableParamData = res.data.data.list;
          } else {
            console.log(res.data.msg);
          }
        })
      },
      //查询公共参数列表
      queryCommonParamList() {
        var data = {
          'name': this.searchKey,
          'pageNo': this.form.pageNo,
          'paramInfo': this.searchVla,
          'gid': this.selectGroupIdVal,
          'pageSize': this.form.pageSize,
          'token': this.token
        };
        api.queryCommonParamList(data).then(res => {
          if (res.data.code == 0) {
            this.tableParamData = res.data.data.list;
            this.totalParamCount = res.data.data.totalSize;
            //console.log(res);
          } else {
            console.log(res.data.msg);
          }
        })
      },
      //查询分组列表
      queryCommonGroupListAll() {
        var data = {
          'pageNo': 1,
          'pageSize': 10000,
          'token': this.token
        };
        api.queryCommonGroupList(data).then(res => {
          if (res.data.code == 0) {
            this.options = res.data.data.list;
          } else {

          }
        })
      },
      editCommonParamHander() {
        this.saveCommonParam();
      },
      saveCommonParam() {
        var obj = {
          "id": this.form.id,
          "name": this.form.name,
          "paramInfo": this.form.paramInfo,
          "type": this.selectParamTypevalue,
          "paramDesc": this.form.paramDesc
        }
        var data = {
          "groupId": this.selectGroupIdvalue,
          "token": this.token,
          params: [obj]
        };
        api.saveCommonParam(data).then(res => {
          if (res.data.code == 0) {
            this.dialogFormVisible = false;
            this.clearAddCommonParam();
            this.queryCommonParamList();
            successMsg({message: "保存成功"})
          } else {
            errorMsg({
              message: res.data.msg
            })
          }
        })
      },
      dialogVisible1() {
        this.dialogVisible = true;
        this.form.ids = this.handleSelectionChange.map(item => item.id);
      },
      delCommonPara() {
        // this.form.ids = this.handleSelectionChange.map(item => item.id);
        // if(this.form.ids.length ==0){
        //   warningMsg({message:"请选择要删除的参数"});
        //   return;
        // }
        this.dialogVisible = false;
        var ids = [];
        if (this.form.ids.length == 0) {
          ids = this.form.ids;
        } else {
          ids = this.form.ids;
          var data = {
            'ids': this.form.ids,
            'token': this.token
          };
          api.delCommonParam(data)
            .then(res => {
              if (res.data.code == 0) {
                if (this.form.ids.length == 0) {

                } else {
                  this.clearAddCommonParam();
                  this.queryCommonParamList();
                  successMsg({message: "删除成功"})
                }
              } else {
                errorMsg({message: res.data.msg})
              }
            })
        }
      },
      editParamHander(row) {
        console.log(row);
        this.form.id = row.id;
        this.dialogFormVisible = true;
        this.dialogTitle = '编辑参数'
        this.form.name = row.name;
        this.form.paramDesc = row.paramDesc;
        this.form.paramInfo = row.paramInfo;
        this.selectParamTypevalue = row.type;
        this.selectGroupIdvalue = row.groupId;
        this.isdisabledFn = true;
        this.seeBlock = true;
        this.formTo.name = row.name;
        this.formTo.commGropId = row.groupId;
      },
      clearAddCommonParam() {
        this.form.name = "";
        this.form.paramInfo = "";
        this.form.id = "";
        this.form.paramDesc = "";
        this.selectParamTypevalue = "1";
        this.selectGroupIdvalue = "";
      },
      addCommonParamHandler() {
        this.clearAddCommonParam();
        this.dialogFormVisible = true;
        this.dialogTitle = '添加参数'
        this.isdisabledFn = false;
        this.seeBlock = false;
      },
    },
    created() {
      // this.token = this.$cookies.get('USER_TOKEN_COOKIE');
      this.queryCommonParamList();
      this.queryCommonGroupListAll();
    },
    computed: {
      ...mapState('main', ['tableHeight'])
    },
  }
</script>

<style scoped lang="less">
  .terminal {
    .crumbs {
      padding: 10px 0px;
    }

    .header {
      position: relative;
      height: 60px;
      line-height: 60px;

      .paging {
        position: absolute;
        right: 0px;
        top: 10px;
      }

      .search {
        width: 120px;
      }
    }

  }
</style>
